import type { IconSvgObject } from './types';

const FolderVideoIcon: IconSvgObject = [
  ["path", { d: "M8 6.99446H12.0179M12.0179 6.99446H20C21.1046 6.99446 22 7.88989 22 8.99446V13M12.0179 6.99446L9.30008 3.39718C9.11109 3.14703 8.81572 3 8.5022 3H3C2.44772 3 2 3.44772 2 4V19C2 20.1046 2.89543 21 4 21H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 18.5L22 20V16L19 17.5M19 18.5V17.5M19 18.5V20C19 20.5523 18.5523 21 18 21H14C13.4477 21 13 20.5523 13 20V16C13 15.4477 13.4477 15 14 15H18C18.5523 15 19 15.4477 19 16V17.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderVideoIcon;
